import { FormattedMessage } from 'react-intl';
import { Outlet, useNavigate } from 'react-router';

import { useTypedParams } from '@sorare/routing';
import type { Rarity } from '@sorare/core/src/__generated__/globalTypes';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconCollection } from '@sorare/core/src/atoms/icons/system/iconCollection.ts';
import {
  ANY_SPORT_PLAY_BOARDS_PRO_BOARD,
  ANY_SPORT_PLAY_BOARDS_PRO_BOARD_MISSIONS_COLLECT_RARITY,
} from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useSafePreviousNavigate } from '@sorare/core/src/hooks/useSafePreviousNavigate';

import { ProMissionsPageLayout } from '#src/pages/ProMissionsPageLayout/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const BoardMissionsCollectLayout = () => {
  const { board, rarity } = useTypedParams<PageParams>();
  const { generateSportContextPath } = useSportContext();
  const navigate = useNavigate();
  const goBack = useSafePreviousNavigate(
    generateSportContextPath(ANY_SPORT_PLAY_BOARDS_PRO_BOARD, {
      params: { board },
    })
  );

  return (
    <ProMissionsPageLayout
      rarity={rarity as Rarity}
      categoryIcon={<FontAwesomeIcon icon={iconCollection} />}
      categoryTitle={<FormattedMessage defaultMessage="Collect" />}
      goBack={goBack}
      onSelectRarity={R =>
        navigate(
          generateSportContextPath(
            ANY_SPORT_PLAY_BOARDS_PRO_BOARD_MISSIONS_COLLECT_RARITY,
            { params: { board, rarity: R } }
          )
        )
      }
    >
      <Outlet />
    </ProMissionsPageLayout>
  );
};

export default BoardMissionsCollectLayout;
